
import React from 'react'
import config from '@apex/lib/config'
import usePending from '@apex/lib/hooks/usePending'
import RemoveButton from './RemoveButton'
import Paragraph from './Paragraph'
import TextInput from './TextInput'
import Heading from './Heading'
import Strong from './Strong'
import Button from './Button'
import Empty from './Empty'
import Form from './Form'
import List from './List'
import Box from './Box'

/**
 * TeamMembers component.
 */

export default function TeamMembers({ team, members, invites, applicationName, applicationURL, onAdd, onRemove }) {
  const team_id = team.id
  const [pending, add] = usePending(onAdd)

  if (members.length == 0 && invites.length == 0) {
    return <Box flex>
      <Paragraph>Invite team members to <Strong>{team.name}</Strong>.</Paragraph>
      <InviteForm
        team={team}
        pending={pending}
        applicationName={applicationName}
        applicationURL={applicationURL}
        onSubmit={add}
        marginTop={8} />
    </Box>
  }

  return <Box flex>
    <Heading size={2}>Members:</Heading>
    <List marginTop={2}>
      <Empty empty={<Paragraph muted>Team has no members.</Paragraph>}>
        {members.map((member, i) => {
          const last = i == members.length - 1
          const email = member.email
          return <List.Item key={email} isLast={last}>
            <Member {...member} onRemove={e => onRemove({ team_id, email })} />
          </List.Item>
        })}
      </Empty>
    </List>

    <Box height={32}></Box>

    <Heading size={2}>Invites:</Heading>
    <List marginTop={2}>
      <Empty empty={<Paragraph muted>Team has no pending invites.</Paragraph>}>
        {invites.map((invite, i) => {
          const last = i == invites.length - 1
          const email = invite.email
          return <List.Item key={email} isLast={last}>
            <Invite {...invite} onRemove={e => onRemove({ team_id, email })} />
          </List.Item>
        })}
      </Empty>
    </List>

    <InviteForm
      team={team}
      pending={pending}
      applicationName={applicationName}
      applicationURL={applicationURL}
      onSubmit={add}
      marginTop={8} />
  </Box>
}

/**
 * Member component.
 */

function Member({ id, name, email, onRemove }) {
  const [pending, remove] = usePending(onRemove)
  return <React.Fragment>
    {name
      ? <Paragraph>{name} &lt;{email}&gt;</Paragraph>
      : <Paragraph>{email}</Paragraph>}
    <RemoveButton pending={pending} onClick={remove} />
  </React.Fragment>
}

/**
 * Invite component.
 */

function Invite({ token, email, onRemove }) {
  const [pending, remove] = usePending(onRemove)
  return <React.Fragment>
    <Paragraph>{email}</Paragraph>
    <RemoveButton pending={pending} onClick={remove} />
  </React.Fragment>
}

/**
 * InviteForm component.
 */

function InviteForm({ team, pending, onSubmit, applicationName, applicationURL, ...props }) {
  return <Form reset onSubmit={onSubmit} {...props}>
    <Box display="grid" gridTemplateColumns="1fr auto" gap={8}>
      <TextInput name="team_id" type="hidden" value={team.id} />
      {applicationName && <TextInput name="application_name" type="hidden" value={applicationName} />}
      {applicationURL && <TextInput name="application_url" type="hidden" value={applicationURL} />}
      <TextInput name="email" label="Email" placeholder="mark@company.com" required width="100%" />
      <Button theme="primary" pending={pending}>Invite member</Button>
    </Box>
  </Form>
}

